import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { c as n } from "../../../../index-CROKJrb5.js";
import { c as p, f as u } from "../../../../create-component-CBAeEoQ6.js";
import { useTextCardStateAtoms as d } from "../TextCardState/index.js";
import { Typography as f } from "../../../Typography/index.js";
import { u as l } from "../../../../react-B_GApDuV.js";
const T = (t) => t === "lg" ? "d1" : "d2", x = n({
  variants: {
    cardSize: {
      sm: "cur-mb-1",
      md: "cur-mb-2",
      lg: "cur-mb-2"
    }
  }
}), j = p(
  "TextCardTitle",
  u(
    ({ as: t = "p", children: e, className: s, ...o }, m) => {
      const { sizeAtom: a } = d(), r = l(a), i = T(r);
      return /* @__PURE__ */ c.jsx(
        f,
        {
          size: i,
          as: t,
          ref: m,
          className: x({ cardSize: r, className: s }),
          ...o,
          children: e
        }
      );
    }
  )
);
export {
  j as TextCardTitle
};
//# sourceMappingURL=index.js.map
